import React, {Component} from "react";
import "./Pou.css"
import Row from "react-bootstrap/Row";
import dataPou from "../../data/dataPou.json";
import {Button, Card, Col} from "react-bootstrap";
import PaginationStep from "./PaginationStep";
import ChoiceButton from "../ChoiceRayon/ChoiceButton";
import Test0 from "./Test0";
import {BsGlobe, BsHouse, BsMailbox, BsTelephoneForward} from "react-icons/bs";
import Container from "react-bootstrap/Container";
import ModulDetail from "./ModulDetail";
import {IoArrowBackSharp} from "react-icons/all";


const data = dataPou;
export default class MainList extends Component {

    constructor(props) {
        super(props);
        //console.log(idn)
        this.state = {
            pou: data,
            pageOfItems: [],
            showBack: false,
            search: null,
            pou0: data,
            pou1: [],
            choice: false,
            kved: "",
            show: false,
            backkved: false

        };
        this.onChangePage = this.onChangePage.bind(this);
        this.searchpou = this.searchpou.bind(this);
        this.changerayon = this.changerayon.bind(this);


    }

    changepou = (id) => {
        console.log(id)
        this.setState(({pou}) => {
            const idx = pou.find((el) => el.id == id);
            console.log(idx);
            const newpou = [idx];
            return {
                pou: newpou,
                showBack: true,
                //backkved: false,
                //choice: false,
            }
        })
    }

    searchSpace = (event) => {
        let keyword = event.target.value !== "" ? event.target.value : null
        console.log(keyword)
        this.setState({
            search: keyword
        })
    }
    changerayon = (idrayon) => {
        console.log(idrayon)
        let test = this.state.pou.filter((data) => {
                if (this.state.pou === null) {
                    //console.log(data.nameTest)
                    return data
                } else if (data.id_rayon == idrayon) {
                    return data
                }
            }
        )
        const sorted = [].concat(test)
            .sort((a, b) => a.pou_nazva_minust > b.pou_nazva_minust ? 1 : -1)
        console.log(sorted);
        this.setState({
            pou1: sorted
        })
        // console.log(test)
        return sorted

    }
    changekved = (kvdata) => {
        console.log(kvdata)
        let kved = this.state.pou.filter((data) => {
                if (this.state.pou === null) {
                    //console.log(data.nameTest)
                    return data
                } else if (data.idkved == kvdata) {
                    return data
                }
            }
        )
        console.log(kved)
        return kved
    }
    searchpou = (e) => {
        const data0 = this.state.pou1;
        // eslint-disable-next-line array-callback-return
        let filtred = this.state.pou.filter((data) => {
                console.log(data0)
                if (this.state.search === null)
                    return data0
                else if (data.pou_nazva.toLowerCase().includes(this.state.search.toLowerCase()) || data.pou_nazva.toLowerCase().includes(this.state.search.toLowerCase())) {
                    return data
                } else if (data.product_nazva.toLowerCase().includes(this.state.search.toLowerCase()) || data.product_nazva.toLowerCase().includes(this.state.search.toLowerCase())) {
                    return data
                }
            }
        )
        this.sort(this.state.search === null ? data0 : filtred)
        this.setState({
            pou: this.state.search === null ? data0 : filtred
        })
        console.log(filtred);
    }

    sort(spisok) {
        const sorted = [].concat(spisok)
            .sort((a, b) => a.pou_nazva_minust > b.pou_nazva_minust ? 1 : -1)
        console.log(sorted);
        this.setState({
            pou: sorted,
        });
    }

    choiceBackHandler = () => {
        const data0 = this.state.pou1;
        this.setState({
            pageOfItems: [],
            showBack: false,
            search: null,
            pou: data0,
        });
    }
    choiceBackRayon = () => {
        const data0 = this.state.pou0;
        this.setState({
            choice: false,
            pou: data0,
            show: true
        });

    }
    choiceBackKved = () => {
        const data0 = this.state.pou0;
        this.setState({
            kved: false,
            pou: data0,
            backkved: true
        });

    }
    choiceBackKved1 = () => {
        // const data0 = this.state.pou0;
        this.setState({
            kved: false,
            pou: this.changekved(this.props.kvdata),
            backkved: true
        });

    }

    onChangePage(pageOfItems) {
        this.setState({pageOfItems: pageOfItems});
    }

    componentDidMount() {
        this.setState({
            choice: this.props.iddata ? true : false,
            kved: this.props.kvdata ? true : false,
            pou: this.props.iddata ? this.changerayon(this.props.iddata) : this.props.kvdata ? this.changekved(this.props.kvdata) : data,

        });

        this.sort(this.props.iddata ? this.changerayon(this.props.iddata) : this.props.kvdata ? this.changekved(this.props.kvdata) : data)  // console.log(this.props.kvdata)
    }

    render() {
        const back = this.state.showBack;
        const backrayon = this.state.choice;
        const rayon = this.state.show;
        const bkbed = this.state.backkved;
        let modul = this.state.pageOfItems.map(pou => {

            return (
                <Card
                    className="cart-company-lg  flex-wrap box   border"
                    key={pou.id}>
                    <hr/>
                    <Row className="row kart" style={{
                        padding: 0
                    }}>
                        <img className="col-md-5 trademark"
                             src={pou.pou_image}
                             alt="Card image cap"
                        />
                        <div className="col md-6 cart-company-lg__title"
                             dangerouslySetInnerHTML={{__html: pou.pou_nazva.toUpperCase()}}/>

                        <hr/>
                    </Row>
                    <div className="col-12 mt-mb-0">
                        { /*  <div className="cart-company-lg__subtitle"> Продукція, послуги</div>*/}
                        <div className="product" dangerouslySetInnerHTML={{__html: pou.product_nazva}}/>
                    </div>
                    <hr/>
                    <hr/>
                    <Row
                        style={{
                            width: "100%",
                            marginBottom: "1rem",
                        }}>
                        <Button className="indetal"
                                onClick={this.changepou.bind(this, pou.id)}> Докладніше</Button></Row>
                </Card>)

        })

        let moduldetail = this.state.pageOfItems.map(pou => {
            // console.log(pou.product_image[2].original)
            return (<div>
                   <Button className="btn" onClick={this.choiceBackHandler}
                            style={{
                                width: "auto",
                                height: "auto",
                                marginTop: "-77px",
                                marginRight: "80%",
                                marginBottom: "0"
                            }}><IoArrowBackSharp style={{
                        width: "2rem", height: "2rem"
                    }}/> Повернутися</Button>
                    <div className="container-pou">
                        <div>
                            <div className="company-main-info">
                                <Row>
                                    <Col className="col-md-4" style={{
                                        padding: "1rem"
                                    }}>
                                        <Row className="kartka">
                                            <img
                                                className="col imagepou"
                                                src={pou.pou_image}
                                                alt="imagepou"
                                                loading="lazy"/>

                                            <div
                                                className="cart-company-lg__box">Юридична назва

                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">{pou.pou_nazva_minust}
                                            </div>
                                            <div
                                                className="cart-company-lg__box">код
                                                ЄДРПОУ
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">{pou.pou_edrpou}
                                            </div>
                                            <div
                                                className="cart-company-lg__box">Керівник
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">{pou.pou_chef}
                                            </div>
                                            <div
                                                className="cart-company-lg__box"><BsHouse style={{
                                                color: "darkred"
                                            }}/> Юридична/Поштова
                                                адреса
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">{pou.adres_ur}
                                            </div>
                                            <div
                                                className="cart-company-lg__box"><BsHouse style={{
                                                color: "darkred"
                                            }}/> Фактична
                                                адреса
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link"> {pou.adres_fact}
                                            </div>

                                            <div
                                                className="cart-company-lg__box"><BsTelephoneForward
                                                style={{
                                                    color: "darkred"
                                                }}/> Телефон
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">{pou.pou_contact}

                                            </div>

                                            <div
                                                className="cart-company-lg__box"><BsMailbox style={{
                                                color: "darkred"
                                            }}/> E-mail
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">
                                                <a
                                                    href='mailto:${pou.adres_mail}'
                                                    target="_blank">{pou.adres_mail}</a>
                                            </div>

                                            <div
                                                className="cart-company-lg__box"><BsGlobe style={{
                                                color: "darkred"
                                            }}/> Сайт
                                            </div>
                                            <div
                                                className="cart-company-lg__list-link">
                                                <a
                                                    href={pou.adres_web}
                                                    rel="nofollow"
                                                    target="_blank">{pou.adres_web}</a>
                                            </div>

                                        </Row>
                                    </Col>

                                    <Col className="col-md-8 telo">
                                        <Row>
                                            <Col md={4}/>

                                            <Col md={8}>
                                                <div style={{
                                                    backgroundColor: "black",
                                                    clipPath: "polygon(50% 0%, 0% 100%, 50% 100%)",
                                                    width: "4rem",
                                                    marginLeft: "4rem"
                                                }}>""
                                                </div>
                                                <div

                                                    className="cart-company-lg__kved ">{pou.pou_kved}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Row>
                                                <div
                                                    className="cart-company-lg__title "
                                                    dangerouslySetInnerHTML={{__html: pou.pou_nazva.toUpperCase()}}/>
                                                <div
                                                    className="cart-company-lg__content"
                                                    dangerouslySetInnerHTML={{__html: pou.pou_content}}/>
                                                <Row style={{
                                                    marginLeft: "2rem",
                                                    marginRight: "30%",
                                                    paddingLeft: "1rem", paddingRight: "2rem"
                                                }}>
                                                    <Col md={6}><img
                                                        className="inside "
                                                        src={pou.product_image[0].original}
                                                        alt=""
                                                        style={{float: 'left',}}
                                                        loading="lazy"/></Col>
                                                    <Col md={6}><img
                                                        className="inside "
                                                        src={pou.product_image[1].original}
                                                        alt=""
                                                        style={{float: 'left',}}
                                                        loading="lazy"/></Col>
                                                </Row>
                                                <Row style={{
                                                    marginBottom: '2rem',
                                                    marginLeft: "2rem",
                                                    marginRight: "2rem",
                                                    paddingLeft: "30%",
                                                    paddingRight: "25%",
                                                    height: "15rem"
                                                }}>
                                                    <Col><img
                                                        className="inside"
                                                        src={pou.product_image[2].original}
                                                        alt=""
                                                        style={{float: 'left',}}
                                                        loading="lazy"/></Col>
                                                </Row>

                                                <div
                                                    className="cart-company-lg__product">ТОВАРИ ТА ПОСЛУГИ
                                                </div>
                                                <ul className="cart-company-lg__content">
                                                    <li dangerouslySetInnerHTML={{__html: pou.product_nazva}}/>

                                                </ul>
                                            </Row>

                                        </Row>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </div>
                    <div>

                    </div>
                    <hr/>

                </div>
            )

        })

        return (!back ?
                !bkbed ?
                    !rayon ?
                        <div>
                            {
                                backrayon ?
                                    <div className="col-auto flex-grow-1">
                                        <Button className="btn "
                                                onClick={this.choiceBackRayon}
                                                style={{
                                                    width: "auto",
                                                    height: "auto",
                                                    marginTop: "-3rem",
                                                    marginBottom: "3rem"
                                                }}><IoArrowBackSharp style={{
                                            width: "2rem", height: "2rem"
                                        }}/> Повернутися до вибору
                                            району </Button>
                                    </div> :
                                    <div className="col-auto flex-grow-1">
                                        <Button className="btn "
                                                onClick={this.choiceBackKved}
                                                style={{
                                                    width: "auto",
                                                    height: "auto",
                                                    marginTop: "-3rem",
                                                    marginBottom: "3rem"
                                                }}><IoArrowBackSharp style={{
                                            width: "2rem", height: "2rem"
                                        }}/> Повернутися до вибору виду діяльності </Button>
                                    </div>}
                            {!back ?
                                <div>
                                    <div style={{
                                        backgroundColor: "black",
                                        clipPath: "polygon(50% 0%, 0% 100%, 50% 100%)",
                                        width: "4rem",
                                        marginLeft: "1rem"
                                    }}>""
                                    </div>
                                    <div
                                        className="cart-company-lg_pagesearch ">Пошук за назвою або
                                        товаром/послугою
                                    </div>

                                    <Row className="col-auto flex-grow-1">
                                        <input className="search-form__input form-control" type="text"
                                               placeholder="Введіть критерій"
                                               onChange={(e) => this.searchSpace(e)}/>
                                        <button className="search-form__submit btn btn-warning"
                                                onClick={this.searchpou} style={{
                                            width: "auto",

                                            marginTop: "0",
                                            marginBottom: "0"
                                        }}> Шукати
                                        </button>
                                    </Row>
                                </div> : ""}
                            <hr/>
                            <div className="container-pou">
                                <div className="text-center">
                                    <div>
                                        <Row md={2} lg={3} style={{margin: "2%"}}> {modul}</Row>
                                    </div>

                                    <PaginationStep items={this.state.pou} onChangePage={this.onChangePage}/>

                                </div>
                            </div>
                            <hr/>
                        </div>
                        :
                        <ChoiceButton/>
                    :
                    <Test0/>
                :
                <div className="container-pou">
                    <div className="text-center">
                        <ModulDetail data={this.state.pou[0]}/>

                        <Container>
                            {moduldetail}

                        </Container>

                        <PaginationStep items={this.state.pou} onChangePage={this.onChangePage}/>

                    </div>
                </div>
        );
    }
}

